/* eslint-disable @typescript-eslint/no-explicit-any */
import 'react-app-polyfill/ie11.js';
import 'react-app-polyfill/stable.js';
import rewritePattern from 'regexpu-core';
import { generateRegexpuOptions } from '@babel/helper-create-regexp-features-plugin/lib/util.js';

if (typeof (window as any).TextEncoder === 'undefined') {
  import('text-encoding').then((mod) => {
    (window as any).TextEncoder = mod.TextEncoder;
  });
}

try {
  new RegExp('a', 'u');
} catch (err) {
  (window as any).RegExp = function (pattern: any, flags: any) {
    if (flags && flags.includes('u')) {
      return new RegExp(
        rewritePattern(
          pattern,
          flags,
          generateRegexpuOptions({ flags, pattern }),
        ),
      );
    }
    return new RegExp(pattern, flags);
  };
  (window as any).RegExp.prototype = RegExp;
}
